// extracted by mini-css-extract-plugin
module.exports = {"root":"IconBarbecue_root__2GJTF"};